import { render } from "./BenefitCard.vue?vue&type=template&id=36f1fdad&scoped=true"
import script from "./BenefitCard.vue?vue&type=script&lang=js"
export * from "./BenefitCard.vue?vue&type=script&lang=js"

import "./BenefitCard.vue?vue&type=style&index=0&id=36f1fdad&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f1fdad"]])

export default __exports__